import mutations from './specRec.mutations'
import actions from './specRec.actions'
import getters from './specRec.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
